import { RoomType } from 'src/types/cartography.types';

/**
 * Noms régionaux et synonymes acceptés par la recherche. Ils ne sont jamais persistés :
 * ils servent à retrouver le type canonique et à pré-remplir le nom de la pièce.
 */
export const ROOM_TYPE_ALIASES: Partial<Record<RoomType, string[]>> = {
  [RoomType.PANTRY]: ['souillarde', 'arrière-cuisine', 'arriere cuisine', 'office', 'cuisine dété'],
  [RoomType.LARDER]: ['cellier', 'garde-manger', 'réserve'],
  [RoomType.ATTIC]: ['grenier', 'combles', 'galetas'],
  [RoomType.BASEMENT]: ['sous-sol', 'soubassement'],
  [RoomType.CELLAR]: ['cave', 'caveau'],
  [RoomType.SHOWER_ROOM]: ['salle deau', 'douche'],
  [RoomType.POWDER_ROOM]: ['cabinet de toilette', 'lave-mains', 'cabinet'],
  [RoomType.TOILET]: ['wc', 'toilettes', 'waters', 'cabinets'],
  [RoomType.ENTRANCE]: ['entrée', 'hall', 'vestibule', 'sas'],
  [RoomType.HALLWAY]: ['couloir', 'dégagement', 'corridor'],
  [RoomType.LANDING]: ['palier'],
  [RoomType.STAIRWELL]: ['escalier', "cage d'escalier"],
  [RoomType.LIVING_ROOM]: ['salon', 'séjour', 'living'],
  [RoomType.DINING_ROOM]: ['salle à manger'],
  [RoomType.RECEPTION_ROOM]: ['salle de réception', 'grande salle', 'orangerie'],
  [RoomType.MASTER_BEDROOM]: ['chambre parentale', 'suite parentale', 'chambre des maîtres'],
  [RoomType.DORMITORY]: ['dortoir', 'chambrée'],
  [RoomType.STUDIO_APARTMENT]: ['studio', 'appartement indépendant', 'gîte'],
  [RoomType.DRESSING_ROOM]: ['dressing', 'penderie'],
  [RoomType.STORAGE_ROOM]: ['débarras', 'rangement', 'cagibi'],
  [RoomType.BOILER_ROOM]: ['chaufferie', 'local technique', 'buanderie technique'],
  [RoomType.WINE_CELLAR]: ['cave à vin', 'cellier à vin'],
  [RoomType.VERANDA]: ['véranda', "jardin d'hiver", 'serre'],
  [RoomType.OUTBUILDING]: ['dépendance', 'annexe', 'communs'],
  [RoomType.BARN]: ['grange', 'hangar'],
  [RoomType.STABLE]: ['écurie', 'étable', 'bergerie'],
  [RoomType.SHED]: ['remise', 'cabanon', 'abri de jardin'],
  [RoomType.WORKSHOP]: ['atelier'],
  [RoomType.COURTYARD]: ['cour', 'patio'],
  [RoomType.TERRACE]: ['terrasse'],
  [RoomType.POOL_HOUSE]: ['pool house', 'local piscine'],
  [RoomType.CARPORT]: ['carport', 'abri voiture', 'auvent'],
  [RoomType.PARKING_SPACE]: ['place de parking', 'stationnement', 'box'],
  [RoomType.GYM]: ['salle de sport', 'fitness'],
  [RoomType.HOME_CINEMA]: ['cinéma', 'salle de projection'],
  [RoomType.LIBRARY]: ['bibliothèque'],
  [RoomType.PLAYROOM]: ['salle de jeux', 'playroom'],
  [RoomType.LAUNDRY]: ['buanderie', 'lingerie', 'lavoir'],
  [RoomType.MEZZANINE]: ['mezzanine', 'soupente'],
  [RoomType.LOGGIA]: ['loggia'],
  [RoomType.BALCONY]: ['balcon'],
  [RoomType.GARDEN]: ['jardin', 'parc', 'potager'],
  [RoomType.POOL]: ['piscine', 'bassin'],
  [RoomType.LOBBY]: ["hall d'immeuble", 'entrée commune'],
  [RoomType.BIKE_ROOM]: ['local à vélos', 'local vélo'],
  [RoomType.BIN_ROOM]: ['local poubelles', 'local ordures'],
};
